import toast from "react-hot-toast";

const OPTIONS: any = {
  duration: 2000,
  position: "top-right",
  style: {
    zIndex: 999999,
  },
  ariaProps: {
    role: "status",
    "aria-live": "polite",
  },
  removeDelay: 1000,
};

export const SuccessToast = (message: any, removeDelay?: number) => {
  toast.success(message, {
    ...OPTIONS,
    style: {
      borderRadius: "10px",
      background: "#333",
      color: "#fff",
      fontSize: 15,
      fontWeight: 600,
    },
    iconTheme: {
      primary: "#72c81e",
      secondary: "#fff",
    },
    removeDelay: removeDelay ?? 1000,
  });
};

export const ErrorToast = (message: any) => {
  toast.error(
    (t) => (
      <div style={{ fontSize: 15, fontWeight: 600, paddingRight: 15 }}>
        {message}
        <button
          onClick={() => toast.dismiss(t.id)}
          style={{
            marginLeft: "10px",
            background: "#d6c4c42e",
            border: "none",
            color: "rgb(255, 255, 255)",
            fontWeight: "bold",
            cursor: "pointer",
            borderRadius: "5px",
            padding: "2px 5px",
            fontSize: "12px",
            position: "absolute",
            top: "50%",
            right: "12px",
            transform: "translate(0, -50%)",
          }}
        >
          ✕
        </button>
      </div>
    ),
    {
      ...OPTIONS,
      duration: 5000,
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
        fontSize: 15,
        fontWeight: 600,
      },
      iconTheme: {
        primary: "#d32f2f",
        secondary: "#fff",
      },
    }
  );
};
